.main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 50px;
    box-sizing: border-box;
    position: relative;
    padding: 5px 10px;
    border: var(--border-inactive);
    border-radius: var(--border-radius-small);
    background-color: var(--background-field);
    color: var(--color-shared-field-text);
    cursor: text;
}

.main:focus-within {
    border: var(--border-focus);
    outline: var(--border-focus);
    outline-offset: 0px;
}

.main:hover:not(:focus-within) {
    border: var(--border-hover);
}

.main>input {
    outline: none;
    border: none;
    appearance: none;
    width: 100%;
    font-weight: normal;
    font-size: 24px;
    background-color: var(--background-field);
    -webkit-appearance: none;
    -moz-appearance: none;
}

.main>input::placeholder {
    color: var(--color-shared-secondary);
}

.label {
    position: absolute;
    font-weight: normal;
    font-size: 12px;
    line-height: 100%;
    color: var(--color-label-gray);
    transform: translateY(-50%);
    top: 0px;
    left: 8px;
    background-color: var(--background-field);
    padding-left: 5px;
    padding-right: 5px;
}

.main:focus-within>.label {
    color: var(--color-label-focus);
}

.actions {
    display: block;
    height: 20px;
    color: var(--color-actions-gray);
    cursor: pointer;
}

.actions:hover {
    color: var(--color-actions-hover);
}